import { FindDocumentsTypeEnumNumber } from './../../enums/documents-type.enum';
import { IUser } from 'src/app/core/models/user/user';
import { environment } from 'src/environments/environment';
import { LocalStorageService } from './../../services/local-storage/local-storage.service';
export class Parameters {

    private user: IUser;
    private affiliateDocument: string;
    private affiliateName: string;
    private beneficiaryDocument: string;
    private beneficiaryName: string;
    private dateEnd: string;
    private dateStart: string;
    private idPortal: string;
    private pageNumber: number;
    private pageSize: string;
    private requestCode: string;
    private settledCode: string;
    private state: string;
    private take: string;
    private type: string;
    private typeReason: string;
    private prefix: string;
    private numberDocumentBusiness: string;
    private typeDocumentBusiness: string;

    constructor(private _STORAGE: LocalStorageService){

        this.user = this._STORAGE.parseItem(environment.LOCAL_STORAGE.USER_LOGGED_IN);
        this.affiliateDocument = "";
        this.affiliateName = "";
        this.beneficiaryDocument = "";
        this.beneficiaryName = "";
        this.dateEnd = "";
        this.dateStart = "";
        this.idPortal = "2";
        this.pageNumber = 0;
        this.pageSize = "";
        this.requestCode = "";
        this.settledCode = "";
        this.state = "";
        this.take = "0";
        this.type = "";
        this.typeReason = "";
        this.prefix =  "";
        this.numberDocumentBusiness = this.user.docNumberCompany;
        this.typeDocumentBusiness = FindDocumentsTypeEnumNumber.find(parseInt(this.user.docTypeCompany));
    }

    setAffiliateDocument(affiliateDocument){
        this.affiliateDocument = affiliateDocument;
    }

    setAffiliateName(affiliateName){
        this.affiliateName = affiliateName;
    }

    setBeneficiaryDocument(beneficiaryDocument){
        this.beneficiaryDocument = beneficiaryDocument;
    }

    setBeneficiaryName(beneficiaryName){
        this.beneficiaryName = beneficiaryName;
    }

    setDateEnd(dateEnd){
        this.dateEnd = dateEnd;
    }

    setDateStart(dateStart){
        this.dateStart = dateStart;
    }

    setIdPortal(idPortal){
        this.idPortal = idPortal;
    }

    setPageNumber(pageNumber){
        this.pageNumber = pageNumber;
    }

    setPageSize(pageSize){
        this.pageSize = pageSize;
    }

    setRequestCode(requestCode){
        this.requestCode = requestCode;
    }

    setSettledCode(settledCode){
        this.settledCode = settledCode;
    }

    setState(state){
        this.state = state;
    }

    setTake(take){
        this.take = take;
    }

    setType(type){
        this.type = type;
    }

    setTypeReason(typeReason){
        this.typeReason = typeReason;
    }

    setPrefix(prefix){
      this.prefix = prefix;
    }

    setNumberDocumentBusiness(numberDocumentBusiness: string){
      this.numberDocumentBusiness = numberDocumentBusiness;
    }

    setTypeDocumentBusiness(typeDocumentBusiness: string) {
      this.typeDocumentBusiness = typeDocumentBusiness;
    }
}
